import { Box } from "@mui/joy";
import type { BrandBackdropModuleId } from "../../styles/globalStyles";
import {
  brandBackdropModuleOpacity,
  companyBrandBackdropImgSx,
  moduleBrandBackdropLayerSx,
} from "../../styles/globalStyles";
import { useCompanyBrandLogoSrc } from "../../utils/useCompanyBrandLogoSrc";

type Props = {
  module: BrandBackdropModuleId;
};

export default function CompanyBrandBackdrop({ module }: Props) {
  const { logoSrc, onLogoImgError, hasCompanyLogo } = useCompanyBrandLogoSrc();
  const opacity = brandBackdropModuleOpacity[module];

  return (
    <Box aria-hidden sx={moduleBrandBackdropLayerSx}>
      <Box
        component="img"
        src={logoSrc}
        alt=""
        draggable={false}
        onError={onLogoImgError}
        decoding="async"
        sx={companyBrandBackdropImgSx(hasCompanyLogo, opacity)}
      />
    </Box>
  );
}
